// extracted by mini-css-extract-plugin
export default {"buttons":"AccountInformations_buttons__hfOAJ"};